import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';
import { startCase } from 'lodash';
import cookie from 'vue-cookie'
var querystring = require('querystring');
const tokenAuthCrm = cookie.get('crm_auth_token');

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        // server state vars
        banerSystem: null,
        sales_flatspage_data: null,
        pageSetup: null,
        forms: null,
        //Contacts page
        contactsPage: null,
        contactsCardAnimate: true,
        contactsMapCoords: [],
        pinCoords: {
            lat: null,
            lng: null,
        },
        // end contacts page

        salesCardPage: null,
        salesCardContent: null,
        saleCardItem: null,
        saleFilterParams: null,

        //
        formConsultData: null,
        isOpenSendwich: false,
        isOpenFormConsult: false,


        flats: null,
        flatCards: [],
        flatCardsDefault: [],
        flatsCardsGlobal: [],
        flatsCardsGlobalDefault: [],
        housesCardsGlobal: [],
        housesCardsGlobalDefault: [],
        activeFlatsClass: 'villa',
        activeFlatsClassKohOta: 'flats',

        flatsItems: null,
        flatCard: null,
        flatsFilterData: null,
        pagin_PageNumber: 1,
        gridView: true,
        flatsEmptyMsg: false,
        objectDataCrm: null,
        visibleFilterMobile: false,
        FilterResetTrigger: false,
        modalData: null,
        hidePaginBtn: false,

        // global data var
        currentCity: null,
        currentPhone: null,
        isOpenSendwichMobile: false,
        isOpenFormLandModal: false,
        animatedEnd: false,
        //  var for flat section
        cardAll: [],
        defaultCountCards: [],
        animateCards: true,

        coockieBanerTopVisible: false,
        // var for news section
        newsData: [],
        gCap_siteKey: '6LfSN84pAAAAALxW_M4tMnaMSIb8hbIkHYTeixWK',
        ucoCRM_oauth_token: null,
    },
    getters: {
        loadGcap_sitekey: state => state.gCap_siteKey,
        loadUcoCRM_auth_token: state => state.ucoCRM_oauth_token,
        loadBanerSystem: state => state.banerSystem,
        loadSalesFlatsPageData: state => state.sales_flatspage_data,
        loadPageSetUp: state => state.pageSetup,
        loadForms: state => state.forms,

        loadSalesCardPage: state => state.salesCardPage,
        loadSalesCardContent: state => state.salesCardContent,
        loadSaleCardItem: state => state.saleCardItem,
        loadSalesFilterCardParams: state => state.saleFilterParams,

        //CONTACTS PAGE
        loadContactsPage: state => state.contactsPage,
        loadContactsCardAnimate: state => state.contactsCardAnimate,
        loadContactsMapCoords: state => state.contactsMapCoords,
        loadPinCoords: state => state.pinCoords,
        //end contacts getters

        loadFormConsultData: state => state.formConsultData,
        loadOpenSendwich: state => state.isOpenSendwich,
        loadOpenFormConsult: state => state.isOpenFormConsult,

        loadFlatsPage: state => state.flats,
        loadFlatsData: state => state.flatCards,
        loadActiveFlatsClass: state => state.activeFlatsClass,
        loadActiveFlatsClassKohOta: state => state.activeFlatsClassKohOta,

        loadFlatsItems: state => state.flatsItems,
        loadFlatCard: state => state.flatCard,
        loadFlatsFilterData: state => state.flatsFilterData,
        loadPaginPageNumber: state => state.pagin_PageNumber,
        loadFlatsEmptyMsg: state => state.flatsEmptyMsg,
        loadObjectDataCrm: state => state.objectDataCrm,
        loadVisibleFilterMobile: state => state.visibleFilterMobile,
        loadLandFlatsGridView: state => state.gridView,
        loadSalesLandModalDataArr: state => state.modalData,
        loadResetTriggerMove: state => state.FilterResetTrigger,
        loadHidePaginBtn: state => state.hidePaginBtn,


        // loadFlatsCardsDefault: state => state.flatCardsDefault,
        loadFlatsCardsGlobal: state => state.flatsCardsGlobal,
        loadFlatsCardsGlobalDefault: state => state.flatsCardsGlobalDefault,

        loadSalesLandCardAnimate: state => state.animateCards,
        loadNewsData: state => state.newsData,
        // custom
        loadIsOpenFormLandModal: state => state.isOpenFormLandModal,
        loadisOpenFormModal: state => state.isOpenFormModal,
        loadIsOpenSendwich: state => state.isOpenSendwich,
        loadIsOpenSendwichMobile: state => state.isOpenSendwichMobile,
        loadCockieBanerTopVisible: state => state.coockieBanerTopVisible,
        loadCurCity: state => state.currentCity,
        loadCurPhone: state => state.currentPhone,
    },
    actions: {
        getFullSetUpProject({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(window.url + window.GlobalLang + window.JsonUrl + 'settings').then(async (response) => {
                    // console.log(response, 'full setup sales');
                    commit('setBanerSystem', response.data[0].acf);
                    commit('PageSetUp', response.data[1].acf);
                    commit('formsData', response.data[2].acf);
                    resolve('complete');
                });
            });
        },
        // SALES CARD PROMO/LAND
        getSalesCardPageData({commit}) {
            axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/561').then(async (response) => {
                // console.log(response.data.acf, 'sale CARD PAGE DATA DEFAULT');
                commit('salesCardPage', response.data.acf);
            });
        },
        getFlatsPageData({commit}) {
            axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/286').then(async (response) => {
                // console.log(response.data.acf);
                commit('Sales_flatsPage', response.data.acf);
            });
        },
        getSalesCardContent({commit}, payload) {
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/projects/?filter[project_name]=' + payload).then(async (response) => {
                // console.log(response, 'beta');
                // console.log(response.data, payload, 'content Sales Card Land App')
                commit('salesCardContent', response.data[0].acf);
                // commit('setCurCity', response.data[0].acf.city_name_sales);
                if (payload == 'aqualina') {
                    // console.log('YES')
                    commit('setFlatsAqualina', response.data[0].acf.flats);
                } else if (payload == 'kohota') {
                    commit('setFlatsKohota', response.data[0].acf);
                }
            });
            // axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/projects?slug=' + payload).then(async (response) => {
            //     console.log(response.data, payload, 'content Sales Card Land App')
            //     commit('salesCardContent', response.data[0].acf);
            //     commit('setCurCity', response.data[0].acf.city_name_sales);
            // });
        },
        getSaleItemCard({commit}, payload) {
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/sales/?filter[project_name]=' + payload).then(async (response) => {
                // console.log(response, 'beta');
                // console.log(response.data, payload, 'content Sales ITEM')
                commit('saleItemCard_Set', response.data[0].acf);
                commit('setCurCity', response.data[0].acf.city_name);
            });
        },
        getSaleItemFiltersParams({commit}, payload) {
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/sales-filters/?filter[project_name]=' + payload).then(async (response) => {
                // console.log(response, 'beta');
                // console.log(response.data, payload, 'content FILTER SALES ITEMS PARAMS')
                commit('FilterSaleItemCard_Set', response.data[0].acf);
                // commit('setCurCity', response.data[0].acf.city_name);
            });
        },
        // END SALES CARD PROMO/LAND
        getContactsPageData({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/291').then(async (response) => {
                    // console.log(response.data.acf, 'CONTACTS');
                    commit('contactsPage', response.data.acf);
                    resolve('complete');
                });
            });
        },
        
        getFlatsCards({commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.get('https://flats.bazis.kz/cms/wp-json/wp/v2/' + payload + '/?per_page=100').then(async (response) => {
                    // console.log(response, 'FLATS');
                    commit('FlatsCardsGlobalArr', response.data);
                    resolve('complete');
                });
            });
        },
        // FLATS FROM CRM
        // OAUTH 2.0 REST API CRM REQUETS
        getFlatsItems({commit, dispatch, state}, payload) { // FLATS DEFAULT LOAD
            if (this.state.flatsItems == null) {
                return new Promise((resolve, reject) => {
                    const tokenAuthCrm = cookie.get('crm_auth_token');
                    axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                        headers: { 
                            'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                        } 
                    }).then((response) => {
                        commit('flatsItemsArr', response.data.data);
                        resolve('complete FLATS');
                        // console.log(response, response.data.data, 'apartments after AUTH');
                    }).catch((error) => {
                        console.log('error getApartments default', error.response.data, error.response.status);
                    });
                });
            }
        },
        getFlatsByFilter({commit, dispatch, state}, payload) { // FLATS LOAD BY FILTER
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                commit('flatsItemsArr', response.data.data);
                // console.log(response, response.data.data, 'FILTER APPS after AUTH');
            }).catch((error) => {
                console.log('error getApartments filter', error.response.data, error.response.status);
            });
        },
        getFlatsByPagination({commit, dispatch, state}, payload) { // FLATS LOAD BY pagination with filter and pagePaginNumber params
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                commit('flatsItemsArrPagination', response.data.data);
                console.log(response, response.data.data, 'pagination after AUTH');
            }).catch((error) => {
                console.log('error getApartments pagination', error.response.data, error.response.status);
            });
        },
        // OBJECT HOUSE FROM CRM 
        getObjectFromCRM({commit, dispatch, state}, payload) {
            axios.post(window.CRMurl + '/rest/prices/getComplexes', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                commit('setObjectDataCRM', response.data.data);
                // console.log(response, response.data.data, 'getComplexes after AUTH');
            }).catch((error) => {
                console.log('error getComplexes', error.response.data, error.response.status);
                commit('setObjectDataCRM', []);
            });
        },  
        getCrmAuthToken({commit}, payload) { // Получение Токена из СРМ системы для oauth 2.0 в необходимых для авторизации запросов
            return new Promise((resolve, reject) => {
                axios.post('https://admin.sales.bazis.kz/server/new-auth.php', querystring.stringify({'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ=='})).then((response) => {
                    if (response) {
                        var tokenParse = JSON.parse(response.data.token);
                        var token = tokenParse.access_token;
                        commit('setOauthToken_from_server', token);
                        resolve(true);
                        // console.log(token,'- token');
                    } else {
                        resolve(false);
                    }
                    // cookie.set('crm_auth_token', response.data.access_token, { expires: response.data.expires_in + 's' });
                }).catch((error) => {
                    console.log('error ' + error, 'erorr Get Token');
                    resolve(false);
                });
            });
        },
        // getCrmAuthToken({commit}, payload) { // Получение Токена из СРМ системы для oauth 2.0 в необходимых для авторизации запросов
        //     axios.post('https://sales.bazis.kz/server/auth.php', querystring.stringify({'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ=='})).then((response) => {
        //         cookie.set('crm_auth_token', response.data.access_token, { expires: response.data.expires_in + 's' });
        //         if (payload == 'after_error_token_invalid') {
        //             location.reload();
        //         }
        //     }).catch((error) => {
        //         console.log('error ' + error, 'erorr Get Token');
        //     });
        // },
        // getCrmAuthChecker({commit, dispatch}, payload) { // Проверка 401 ошибки когда токен истек (на случай обновления сервера СРМ)
        //     // console.log(tokenAuthCrm, payload)
        //     if (payload != undefined && payload.error == 'invalid_token') {
        //         dispatch('getCrmAuthToken', 'after_error_token_invalid');
        //     } else if (tokenAuthCrm == null && tokenAuthCrm == undefined) {
        //         dispatch('getCrmAuthToken');
        //     }
        // },
        // action for flat section
        clearFlatCardAll({commit}, payload) {
            commit('cardAllClear', payload);
        },
        clearNewsData({commit}) {
            commit('newsDataClear');
        }
    },
    mutations: {
        setOauthToken_from_server(state, data) {
            state.ucoCRM_oauth_token = data;
        },
        // Main server mutations
        setBanerSystem(state, data) {
            state.banerSystem = data
        },
        Sales_flatsPage(state, data) {
            state.sales_flatspage_data = data
        },
        PageSetUp(state, setup) {
            state.pageSetup = setup
        },
        formsData(state, data) {
            state.forms = data
        },
        // server mutations
        salesCardPage(state, data) {
            state.salesCardPage = data;
        },
        salesCardContent(state, data) {
            state.salesCardContent = data;
        },
        saleItemCard_Set(state, data) {
            state.saleCardItem = data
        },
        FilterSaleItemCard_Set(state, data) {
            state.saleFilterParams = data
        },
        //contacts page
        contactsPage(state, data) {
            state.contactsPage = data
        },
        setContactsCardAnimation(state, data) {
            state.contactsCardAnimate = data
        },
        filterContactsMapCoords(state, data) {
            state.contactsMapCoords = data
        },
        setContactsPinCoords(state, data) {
            // console.log(data)
            state.pinCoords.lat = data.lat,
            state.pinCoords.lng = data.lng
        },
        // end contacts page
        setCurCity(state, data) {
            state.currentCity = data;
        },
        coockieBanerTopVisible(state, data) {
            state.coockieBanerTopVisible = data;
        },
        getFormConsultData(state, data) {
            state.formConsultData = data
        },
        Open_form_Consult(state, data) {
            state.isOpenFormConsult = data
        },
        Open_FormLandModal(state, data) {
            state.isOpenFormLandModal = data
        },
        Flats(state, flats) {
            state.flats = flats
        },
        FlatsCardsGlobalArr(state, data) {
            var flatsArr = [];
            state.flatsCardsGlobal = [];
            state.flatsCardsGlobalDefault = [];
            for (var i = 0; i < data.length; i++) {
                flatsArr.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                    slug: data[i].slug,
                }));
            }
            state.flatsCardsGlobal = flatsArr;
            state.flatsCardsGlobalDefault = flatsArr;
        },
        changeActiveFlatsClass(state, data) {
            state.activeFlatsClass = data
            state.activeFlatsClassKohOta = data
        },
        // global mutations for vars
        Open_Form_Modal(state, data) {
            state.isOpenFormModal = data
        },
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        Open_sendwich_mobile(state, data) {
            state.isOpenSendwichMobile = data
        },
        Animation_End(state, data) {
            state.animatedEnd = data
        },
        // mutations for flat section
        cardAll(state, allcards) {
            state.cardAll.push(allcards);
        },
        cardAllClear(state, data) {
            state.flatsCardsGlobal = [];
            state.flatsCardsGlobal = data;
            // console.log(data, 'FLATS filter data')
        },
        setCardAllToDefault(state, setDefault) {
            state.cardAll = [];
            state.cardAll = setDefault;
        },
        defaultCountCards(state, defaultCards) {
            state.defaultCountCards = defaultCards;
        },
        
       
        animateCards(state, data) {
            state.animateCards = data;
        },
        // mutations for news section
        newsData(state, data) {
            state.newsData.push(data);
        },
        newsDataClear(state, data) {
            state.newsData = []
        },
        setFlatsAqualina(state, data) {
            state.flatsCardsGlobal = data;
            state.flatsCardsGlobalDefault = data;
        },
        setFlatsKohota(state, data) {
            state.flatsCardsGlobal = data.flats;
            state.flatsCardsGlobalDefault = data.flats;

            state.housesCardsGlobal = data;
            state.housesCardsGlobalDefault = data;
        },
        updateFlatsKohOta(state, data) {
            if (data == 'flats') {
                state.flatsCardsGlobal = state.housesCardsGlobal.flats;
                state.flatsCardsGlobalDefault = state.housesCardsGlobal.flats;
            } else {
                state.flatsCardsGlobal = state.housesCardsGlobal.houses;
                state.flatsCardsGlobalDefault = state.housesCardsGlobal.houses;
            }
        },

        // flats from CRM
        flatsItemsArr(state, data) {
            // console.log(data, 'test')
            state.flatsItems = data;
            if (data.length == 0) {
                state.flatsEmptyMsg = true
            } else {
                state.flatsEmptyMsg = false
            }
        },
        flatsItemsArrPagination(state, data) {
            console.log(data, data.length, 'PAGINATION MUTATION');
            for (var i = 0; i < data.length; i++) {
                state.flatsItems.push(data[i]);
            }
            if (data.length == 0) {
                state.hidePaginBtn = true
            }
            // console.log(state.flatsItems);
        },
        setObjectDataCRM(state, data) {
            state.objectDataCrm = data[0];
        },
        setFlatsFilterData(state, data) {
            state.flatsFilterData = data
        },
        UpdatePaginPageNumber(state, data) {
            state.pagin_PageNumber = data
        },
        // for flats
        SetVisibleFilterMobile(state, data) {
            state.visibleFilterMobile = data
        },
        TriggerResetFilterMove(state, data) {
            state.FilterResetTrigger = data
        },
        gridView(state, data) {
            state.gridView = data;
        },
        modalData(state, data) {
            state.modalData = data
        },
    }
})
